import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, Loader2, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';

export default function ForcePasswordChange() {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [saving, setSaving] = useState(false);
  const { refresh } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error('Minimo 6 caratteri');
    if (pw !== pw2) return toast.error('Le password non coincidono');
    setSaving(true);
    try {
      const { data } = await api.put('/users/me/password', { password: pw });
      if (data.token) localStorage.setItem('gtc_token', data.token);
      toast.success('Password aggiornata');
      await refresh();
      window.location.href = '/admin';
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Errore');
    } finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative" data-testid="force-password-change">
      <div className="absolute inset-0 -z-0">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.15)_0%,transparent_60%)]" />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="relative w-full max-w-sm"
      >
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-[var(--gold-soft)] border border-[var(--gold)]/40 flex items-center justify-center gold-glow">
            <ShieldCheck className="w-8 h-8 text-[var(--gold)]" strokeWidth={1.7} />
          </div>
          <h1 className="font-heading text-2xl mt-5 font-light">Cambio password obbligatorio</h1>
          <p className="text-xs text-white/60 mt-3 text-center leading-relaxed">
            Per motivi di sicurezza devi impostare una password personale prima di accedere al pannello.
          </p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50 mb-2 block">Nuova password</label>
            <input
              data-testid="force-new-pw" type="password" value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="input-gold" placeholder="••••••••" minLength={6} required
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50 mb-2 block">Ripeti password</label>
            <input
              data-testid="force-new-pw2" type="password" value={pw2}
              onChange={(e) => setPw2(e.target.value)}
              className="input-gold" placeholder="••••••••" minLength={6} required
            />
          </div>
          <button data-testid="force-submit" type="submit" disabled={saving} className="btn-gold w-full py-4 flex items-center justify-center gap-2">
            {saving ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Lock className="w-4 h-4" /> Aggiorna password</>}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
